import { render, staticRenderFns } from "./locadorPrestadorReport.vue?vue&type=template&id=bc96332a"
import script from "./locadorPrestadorReport.vue?vue&type=script&lang=js"
export * from "./locadorPrestadorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports